/**
 * 2026: no late Jan–Aug; September only +$76 spayed / +$79 non-spayed (no monthly, no delinquency).
 * Keep in sync with Backend/src/services/common.service.ts
 */
export const PET_2026_FLAT_LATE_SPAYED = 76;
export const PET_2026_FLAT_LATE_NON_SPAYED = 79;

/**
 * Total pet license fee (base tier + late). Non-2026: standard monthly + delinquency after August.
 * @param isSpayedNeutered - For 2026 September flat late ($76 vs $79)
 */
export const calculatePetLicenseFee = (
  fee: number,
  lateMonthlyFee = 0,
  delinquencyFee = 0,
  date: Date = new Date(),
  isSpayedNeutered?: boolean,
): number => {
  const baseFee = Number(fee) || 0;
  const monthlyFee = Number(lateMonthlyFee) || 0;
  const delFee = Number(delinquencyFee) || 0;

  if (!baseFee || isNaN(baseFee)) {
    return 0;
  }

  const month = date.getMonth() + 1;
  const year = date.getFullYear();

  if (year === 2026) {
    if (month >= 1 && month <= 8) {
      return baseFee;
    }
    if (month === 9) {
      const lateFlat =
        isSpayedNeutered === true
          ? PET_2026_FLAT_LATE_SPAYED
          : PET_2026_FLAT_LATE_NON_SPAYED;
      return baseFee + lateFlat;
    }
    return baseFee;
  }

  if (month === 1) {
    return baseFee;
  } else if (month >= 2 && month <= 8) {
    return baseFee + (month - 1) * monthlyFee;
  } else {
    return baseFee + 7 * monthlyFee + delFee;
  }
};

/**
 * Late fee only (total − base tier subtotal)
 */
export const getLateFeeAmount = (
  baseFee: number,
  lateMonthlyFee = 0,
  delinquencyFee = 0,
  date: Date = new Date(),
  isSpayedNeutered?: boolean,
): number => {
  const total = calculatePetLicenseFee(
    baseFee,
    lateMonthlyFee,
    delinquencyFee,
    date,
    isSpayedNeutered,
  );
  return Math.max(0, total - (Number(baseFee) || 0));
};

/** Align with backend getPetFeeBreakdown / cart — truthy waive zeros late fees */
export const isPetLateFeesWaived = (value: unknown): boolean =>
  value === true || value === 1 || value === '1' || value === 'true';
